<template>
  <div class="custom-container">
    <b-row
      class="justify-content-between px-1 pb-1 pt-0 pt-sm-1 align-items-center"
    >
      <div class="pos-header">
        <h1 class="font-weight-bolder mb-0">
          {{ $t('add', { type: $t('products') }) }}
        </h1>
        <div
          v-if="stockableContextLabel"
          class="stockable-highlight mt-50"
        >
          <feather-icon
            icon="MapPinIcon"
            size="18"
            class="stockable-highlight__icon"
          />
          <div class="stockable-highlight__content">
            <span class="stockable-highlight__label">
              {{ stockableContextPrefix }}
            </span>
            <strong class="stockable-highlight__name">
              {{ stockableContextLabel }}
            </strong>
          </div>
        </div>
      </div>
      <div
        v-if="$route.name === 'addProductsToQuote'"
        class="d-flex align-items-center"
      >
        <div class="mr-1 d-flex flex-wrap">
          <div class="d-flex justify-content-between mb-1">
            <div>
              <feather-icon
                :id="`tooltip-limit-suppliers`"
                icon="HelpCircleIcon"
                size="20"
                color="#340668"
                class="mr-50"
              />
              <b-tooltip
                :target="`tooltip-limit-suppliers`"
                triggers="hover"
                boundary-padding="10"
              >
                <span>
                  {{ $t('limitSuppliersInfo') }}
                </span>
              </b-tooltip>
              <span class="ml-0 mr-1">
                {{ $t('limitSuppliers') }}
              </span>
            </div>
            <b-form-checkbox
              v-model="quote.limit_suppliers"
              class=""
              name="check-button"
              switch
              @change="setLimitSuppliersValue"
            />
          </div>

          <div class="d-flex justify-content-between">
            <div>
              <feather-icon
                :id="`tooltip-express`"
                icon="HelpCircleIcon"
                size="20"
                color="#340668"
                class="mr-50"
              />
              <b-tooltip
                :target="`tooltip-express`"
                triggers="hover"
                boundary-padding="10"
              >
                <span>
                  {{ $t('expressQuoteDescription') }}
                </span>
              </b-tooltip>
              <span class="ml-0 mr-1">
                {{ $t('expressdelivery') }}
              </span>
            </div>
            <b-form-checkbox
              v-model="quote.is_express"
              class=""
              name="check-button"
              switch
              @change="setExpressValue"
            />
          </div>
        </div>
        <b-button
          class="mr-1"
          :size="isSmallScreen ? 'sm' : 'md'"
          variant="primary"
          @click="saveQuoteProducts()"
        >
          {{ $t('save') }}
        </b-button>
        <b-overlay :show="publishLoading">
          <b-button
            :size="isSmallScreen ? 'sm' : 'md'"
            variant="outline-primary"
            @click="handleRequestQuoteClick"
          >
            {{ $t('requestQuote') }}
          </b-button>
        </b-overlay>
      </div>
      <div v-else-if="$route.name === 'registerSupplierProduct'">
        <b-button
          :size="isSmallScreen ? 'sm' : 'md'"
          variant="primary"
          @click="saveProducts()"
        >
          {{ $t('save') }}
        </b-button>
      </div>
      <div
        v-else-if="$route.name === 'addGroupedExpenses'"
        class="d-flex"
      >
        <b-dropdown
          id="dropdown-1"
          variant="outline-primary"
          :size="isSmallScreen ? 'sm' : 'md'"
          :text="$t('add', { type: $t('service') })"
          class="mr-2"
        >
          <div class="scrollable">
            <b-dropdown-item
              v-for="expense in expenseTypeCatalogs.filter(
                x => x.name != 'Material',
              )"
              :key="expense.id"
              :disabled="isIncomeAlreadyAdded(expense)"
              @click="addGroupedExpense(expense)"
            >
              {{ expense.name }}
            </b-dropdown-item>
          </div>
        </b-dropdown>
        <!-- <b-form-select
          v-model="expenseType"
          disabled
          class="mr-2 border-primary"
          :options="expensesTypes"
        /> -->
        <b-button
          :size="isSmallScreen ? 'sm' : 'md'"
          variant="primary"
          @click="saveExpenses()"
        >
          {{ $t('save') }}
        </b-button>
      </div>
      <b-button
        v-if="isSmallScreen"
        variant="primary"
        class="position-relative"
        size="sm"
        @click="openModalCart"
      >
        <span
          v-if="posItems.length > 0"
          class="notification-number"
        >
          {{ posItems.length }}
        </span>
        <feather-icon
          icon="ShoppingCartIcon"
          :size="isSmallScreen ? '16' : '17'"
          color="#fff"
        />
      </b-button>
    </b-row>
    <b-row
      v-if="$route.name === 'addProductsToQuote'"
      class="quote-nickname-row mb-1"
    >
      <b-col
        sm="12"
        lg="6"
      >
        <b-form-group
          label="Apodo de cotización (opcional)"
          label-for="quote-nickname"
        >
          <b-form-input
            id="quote-nickname"
            v-model="quote.nickname"
            autocomplete="off"
            maxlength="120"
            placeholder="Ej. Casa muestra / Material eléctrico"
            type="text"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div
      v-if="isRegisteringStockableProducts"
      class="classification-shell"
    >
      <div class="classification-toolbar">
        <div>
          <h2 class="classification-title">
            Clasificar productos pendientes
          </h2>
          <p class="classification-subtitle">
            Agrega productos al catálogo de la sucursal o márcalos como no manejados.
          </p>
        </div>
        <div class="classification-stats">
          <span>{{ productsPagination.total_objects || 0 }}</span>
          pendientes
        </div>
      </div>
    </div>

    <b-row class="mb-1">
      <b-col
        sm="12"
        class="mb-1"
      >
        <div>
          <b-form-input
            v-model="searchQuery"
            class="w-100"
            autocomplete="off"
            type="text"
          />
        </div>
      </b-col>
      <b-col
        v-if="true"
        sm="12"
        class="mb-1 d-flex align-items-start flex-wrap"
      >
        <b-dropdown
          class="mr-2"
          size="md"
          variant="outline-primary"
          left
          :text="selectedCategory === null ? $t('all') : selectedCategory"
        >
          <div class="scrollable">
            <b-dropdown-item
              class="mr-1"
              variant="primary"
              @click="selectedCategory = null"
            >
              {{ $t('all') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-for="category in categories"
              :key="`cat-${category.id}`"
              class="mr-1"
              variant="primary"
              @click="selectedCategory = category.name"
            >
              {{ category.name }}
            </b-dropdown-item>
          </div>
        </b-dropdown>

        <div class="product-tags-filter">
          <v-select
            v-model="selectedTagIds"
            multiple
            label="name"
            :options="tagOptions"
            :reduce="tag => tag.id"
            :placeholder="$t('filterByProductTags')"
            :close-on-select="false"
          />
        </div>

        <!-- <b-form-input
          v-model="searchQuery"
          class="w-100"
          autocomplete="off"
          type="text"
        /> -->
      </b-col>
      <b-col v-else>
        <b-overlay
          :show="categoriesLoading"
          opacity=".9"
        >
          <b-form-input
            v-model="searchQuery"
            class="search-input w-100"
            autocomplete="off"
            type="text"
          />
          <div class="mt-50">
            <b-badge
              pill
              size="sm"
              class="mr-50 mb-50 cursor-pointer"
              :variant="selectedCategory === null ? 'warning' : 'primary'"
              @click="selectedCategory = null"
            >
              Todas
            </b-badge>
            <b-badge
              v-for="category in categories"
              :key="`cat-${category.id}`"
              pill
              size="sm"
              class="mr-50 mb-50 cursor-pointer"
              :variant="
                selectedCategory === category.name ? 'warning' : 'primary'
              "
              @click="selectedCategory = category.name"
            >
              {{ category.name }}
            </b-badge>
          </div>
        </b-overlay>
      </b-col>
    </b-row>

    <b-row
      v-if="isRegisteringStockableProducts"
      class="mb-1"
    >
      <b-col class="bulk-actions">
        <b-form-checkbox
          :checked="allVisibleProductsSelected"
          :indeterminate="someVisibleProductsSelected && !allVisibleProductsSelected"
          class="bulk-actions__check"
          @change="toggleVisibleProductsSelection"
        >
          Seleccionar visibles
        </b-form-checkbox>
        <b-button
          size="sm"
          variant="outline-primary"
          class="mr-1"
          :disabled="selectedProducts.length === 0"
          @click="addSelectedProductsToCart"
        >
          <feather-icon
            icon="PlusIcon"
            size="14"
            class="mr-50"
          />
          Agregar {{ selectedProducts.length || '' }} seleccionados
        </b-button>
        <b-button
          v-if="$route.params.type === 'sucursal'"
          size="sm"
          variant="outline-danger"
          :disabled="selectedProducts.length === 0"
          @click="discardSelectedProducts"
        >
          <feather-icon
            icon="Trash2Icon"
            size="14"
            class="mr-50"
          />
          Enviar {{ selectedProducts.length || '' }} a papelera
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        sm="12"
        lg="9"
        class="products overflow-auto"
        @scroll="handleScroll"
      >
        <b-overlay
          :show="loading"
          opacity="1"
        >
          <div
            v-for="product in productsNotInCart"
            :key="`prod-${product.id}`"
          >
            <product-row
              :product="product"
              :selectable="isRegisteringStockableProducts"
              :selected="selectedProductIds.includes(product.id)"
              @product-updated="handleProductUpdated"
              @selection-changed="setProductSelection"
            />
          </div>
          <div
            v-if="!loading && productsNotInCart.length === 0"
            class="empty-products-state"
          >
            {{ emptyProductsMessage }}
          </div>
          <b-overlay :show="productsLoading">
            <b-card
              v-if="!allPagesLoaded"
              style="height: 90px;"
            />
          </b-overlay>
        </b-overlay>
      </b-col>
      <!-- Only show cart on the side on big enough screens -->
      <b-col
        v-if="isSmallScreen === false"
        class="pos overflow-auto"
        sm="12"
        lg="3"
      >
        <b-overlay
          :show="loading"
          opacity="1"
        >
          <total-cart-items :cart-items-length="posItems.length" />
          <cart
            ref="cart"
            :cart-items="posItems"
          />
        </b-overlay>
      </b-col>
    </b-row>
    <b-modal
      v-if="isSmallScreen === true"
      id="modal-mobile-cart"
      size="xl"
      title=""
      class="modal-h-100"
    >
      <b-row>
        <b-col
          class="pos overflow-auto"
          sm="12"
          lg="3"
        >
          <b-overlay
            :show="loading"
            opacity="1"
          >
            <total-cart-items :cart-items-length="posItems.length" />
            <cart
              ref="cart"
              :cart-items="posItems"
            />
          </b-overlay>
        </b-col>
      </b-row>
    </b-modal>
    <confirmation-modal
      ref="confirmModal"
      @confirm="saveAndPublish"
    >
      <template v-slot:content>
        {{ $t('publishQuoteConfirmation') }}
      </template>
    </confirmation-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'underscore'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import vSelect from 'vue-select'
import { sortProductTags } from '@/libs/productTags'
import Cart from '@/components/pos/Cart.vue'
import TotalCartItems from '@/components/pos/TotalCartItems.vue'
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import ProductRow from '@/components/products/ProductRow.vue'

export default {
  components: {
    Cart,
    TotalCartItems,
    ConfirmationModal,
    ProductRow,
    vSelect,
  },

  data() {
    return {
      stockable: {
        stockable_type: this.$route.params.type,
        stockable_id: this.$route.params.id,
        stockable_records: [],
      },
      quote: {
        quote_items_attributes: [],
      },
      cardMode: true,
      selectedCategory: null,
      searchQuery: null,
      loading: false,
      productsLoading: false,
      categoriesLoading: false,
      expensesTypes: [],
      publishLoading: false,
      page: 1,
      showConfirmModal: false,
      selectedProductIds: [],
    }
  },

  computed: {
    ...mapGetters('products', [
      'products',
      'productsPagination',
      'stockableName',
      'selectedProductTagIds',
      'availableProductTags',
      'knownProductTagsById',
    ]),
    ...mapGetters('categories', ['categories']),
    ...mapGetters('pos', ['posItems']),
    ...mapGetters('groupedExpenses', [
      'groupedExpenses',
      'expenseTypeCatalogs',
      'expenseType',
    ]),
    stockableContextLabel() {
      if (this.$route.name !== 'registerSupplierProduct' || !this.stockableName) {
        return null
      }
      return this.stockableName
    },
    stockableContextPrefix() {
      if (!this.stockableContextLabel) {
        return null
      }
      return this.$route.params.type === 'proveedor'
        ? 'Proveedor seleccionado'
        : 'Sucursal seleccionada'
    },
    tagOptions() {
      const availableIds = new Set(this.availableProductTags.map(tag => tag.id))
      const selectedNotAvailable = this.selectedProductTagIds
        .filter(id => !availableIds.has(id))
        .map(id => this.knownProductTagsById[id])
        .filter(Boolean)

      return sortProductTags([...this.availableProductTags, ...selectedNotAvailable])
    },
    selectedTagIds: {
      get() {
        return this.selectedProductTagIds
      },
      set(value) {
        this.setSelectedProductTagIds(value)
      },
    },
    productTagsFilter() {
      return this.selectedProductTagIds.length ? this.selectedProductTagIds : null
    },
    sortedProducts() {
      return [...this.products].sort((a, b) => {
        const nameA = a.name?.trim().toUpperCase() || ''
        const nameB = b.name?.trim().toUpperCase() || ''
        return nameA.localeCompare(nameB)
      })
    },
    posItemIdSet() {
      return new Set(this.posItems.map(item => item.id))
    },
    groupedExpenseSkuSet() {
      return new Set(this.groupedExpenses.map(item => item.sku))
    },
    productsNotInCart() {
      if (this.$route.name === 'addGroupedExpenses') {
        return this.sortedProducts.filter(product => (
          !this.posItemIdSet.has(product.id)
          && !this.groupedExpenseSkuSet.has(product.sku)
        ))
      }

      return this.sortedProducts.filter(product => !this.posItemIdSet.has(product.id))
    },
    breakpoint() {
      return this.$store.getters['app/currentBreakPoint']
    },
    isSmallScreen() {
      switch (this.$store.getters['app/currentBreakPoint']) {
        case 'md':
        case 'sm':
        case 'xs':
          return true
        default:
          return false
      }
    },
    allPagesLoaded() {
      if (this.productsPagination.page < this.productsPagination.total_pages) {
        return false
      }
      return true
    },
    hasSearchOrCategoryFilter() {
      return Boolean(
        (this.searchQuery || '').trim()
        || this.selectedCategory
        || this.selectedProductTagIds.length,
      )
    },
    emptyProductsMessage() {
      if (this.hasSearchOrCategoryFilter) {
        return this.isQuoteCatalog
          ? 'No se encontraron productos con ese criterio disponibles en la zona de tu proyecto'
          : 'No se encontraron productos con ese criterio'
      }

      return this.isQuoteCatalog
        ? 'No hay productos con proveedor disponible en la zona de tu proyecto'
        : 'No hay productos disponibles'
    },
    isRegisteringStockableProducts() {
      return this.$route.name === 'registerSupplierProduct'
    },
    isQuoteCatalog() {
      return this.$route.name === 'addProductsToQuote'
    },
    visibleProductIds() {
      return this.productsNotInCart.map(product => product.id)
    },
    selectedProducts() {
      return this.productsNotInCart.filter(product => this.selectedProductIds.includes(product.id))
    },
    allVisibleProductsSelected() {
      return this.visibleProductIds.length > 0
        && this.visibleProductIds.every(id => this.selectedProductIds.includes(id))
    },
    someVisibleProductsSelected() {
      return this.visibleProductIds.some(id => this.selectedProductIds.includes(id))
    },
  },

  watch: {
    searchQuery: _.debounce(function search() {
      this.page = 1
      this.changeProductsPagination({ field: 'page', value: this.page })
      this.fetchData()
    }, 400),

    selectedCategory() {
      this.page = 1
      this.changeProductsPagination({ field: 'page', value: this.page })
      this.filterBy()
    },

    selectedProductTagIds() {
      this.page = 1
      this.changeProductsPagination({ field: 'page', value: this.page })
      this.fetchData()
    },
  },

  created() {
    this.categoriesLoading = true
    this.setSelectedProductTagIds([])
    this.fetchCategories({ by_active_status: true }).then(() => {
      this.categoriesLoading = false
    })
    this.initializeView()
  },

  destroyed() {
    this.clearPos()
    this.clearProducts()
  },

  methods: {
    ...mapMutations('groupedExpenses', {
      setExpenseType: 'SET_EXPENSE_TYPE',
    }),
    ...mapMutations('products', {
      changeProductsPagination: 'CHANGE_PRODUCTS_PAGINATION',
      setProducts: 'SET_PRODUCTS',
      setSelectedProductTagIds: 'SET_SELECTED_PRODUCT_TAG_IDS',
    }),
    ...mapActions('products', [
      'fetchProducts',
      'fetchStockableContext',
      'addStockableProductSelections',
      'discardStockableProducts',
    ]),
    ...mapActions('groupedExpenses', [
      'fetchGroupedExpenses',
      'addGroupedExpenses',
      'fetchExpensesTypeCatalogs',
    ]),
    ...mapActions('categories', ['fetchCategories']),
    ...mapActions('quotes', [
      'editQuote',
      'fetchQuote',
      'publishQuote',
      'setQuoteBidding',
    ]),
    ...mapMutations('pos', {
      addItem: 'ADD_ITEM_TO_POS',
      setPosItems: 'SET_POS_ITEMS',
      clearPos: 'CLEAR_POS_ITEMS',
    }),
    ...mapMutations('products', {
      clearProducts: 'CLEAR_PRODUCTS',
    }),

    scrollToCart() {
      const el = this.$refs.cart.$el
      el.scrollIntoView({ behavior: 'smooth' })
    },

    openModalCart() {
      this.$bvModal.show('modal-mobile-cart')
    },

    initializeView() {
      this.loading = true

      this.loadInitialContext()
        .then(() => this.fetchData())
        .finally(() => {
          this.loading = false
        })
    },

    loadInitialContext() {
      if (this.$route.name === 'addProductsToQuote') {
        return this.fetchQuote(this.$route.params.quoteId).then(quote => {
          this.quote = quote
          const preloadedItems = this.quote.quote_items_attributes
            .map(quoteItem => {
              const product = quoteItem.product_catalog
              if (!product) {
                return null
              }

              return {
                ...product,
                quantity: quoteItem.quantity,
              }
            })
            .filter(Boolean)

          this.setPosItems(preloadedItems)
        })
      }

      if (this.$route.name === 'registerSupplierProduct') {
        return this.fetchStockableContext({
          stockable: {
            id: this.$route.params.id,
            type: this.stockableTypeForRoute(),
          },
          params: {
            meta: {
              pagination: {
                page: 1,
                per_page: 1,
              },
            },
          },
        })
      }

      if (this.$route.name === 'addGroupedExpenses') {
        return Promise.all([
          this.fetchGroupedExpenses({
            projectId: this.$route.params.projectId,
          }),
          this.fetchExpensesTypeCatalogs(this.$route.params.projectId),
        ]).then(response => {
          const [, expensesTypes] = response
          this.expensesTypes = expensesTypes.data.map(expense => ({
            text: expense.name,
            value: expense.id,
          }))
          const expenseType = this.expensesTypes.find(
            expense => expense.text === 'Material',
          ).value
          this.setExpenseType(expenseType)
        })
      }

      return Promise.resolve()
    },

    fetchData() {
      this.loading = true
      const params = {
        by_active_status: true,
        by_category: this.selectedCategory || null,
        by_name: this.searchQuery ? this.searchQuery : null,
        by_product_tags: this.productTagsFilter,
        by_column: { order: 'ASC', column: 'name' },
        meta: {
          pagination: this.productsPagination,
        },
      }

      if (this.$route.name === 'registerSupplierProduct') {
        params.by_stockable = {
          id: this.$route.params.id,
          type: this.$route.params.type === 'sucursal' ? 'SupplierBranch' : 'Supplier',
        }
      }

      if (this.isQuoteCatalog) {
        params.by_quote_coverage = this.$route.params.quoteId
      }

      return this.fetchProducts(params).finally(() => {
        this.loading = false
      })
    },

    handleProductUpdated() {
      this.selectedProductIds = []
      this.fetchData()
    },

    setProductSelection({ product, selected }) {
      if (selected && !this.selectedProductIds.includes(product.id)) {
        this.selectedProductIds = [...this.selectedProductIds, product.id]
      } else if (!selected) {
        this.selectedProductIds = this.selectedProductIds.filter(id => id !== product.id)
      }
    },

    toggleVisibleProductsSelection(selected) {
      if (selected) {
        this.selectedProductIds = Array.from(new Set([
          ...this.selectedProductIds,
          ...this.visibleProductIds,
        ]))
      } else {
        this.selectedProductIds = this.selectedProductIds.filter(id => !this.visibleProductIds.includes(id))
      }
    },

    addSelectedProductsToCart() {
      this.selectedProducts.forEach(product => {
        if (!this.posItems.find(item => item.id === product.id)) {
          this.addItem({ ...product, quantity: null })
        }
      })
      this.selectedProductIds = []
    },

    stockableTypeForRoute() {
      return this.$route.params.type === 'sucursal' ? 'SupplierBranch' : 'Supplier'
    },

    discardSelectedProducts() {
      const productCatalogIds = [...this.selectedProductIds]
      if (productCatalogIds.length === 0) return

      this.discardStockableProducts({
        stockable_id: this.$route.params.id,
        stockable_type: this.stockableTypeForRoute(),
        product_catalog_ids: productCatalogIds,
      }).then(() => {
        this.selectedProductIds = []
        this.fetchData()
      })
    },

    isIncomeAlreadyAdded(expense) {
      if (expense.name === 'Material') return false
      if (
        this.groupedExpenses.find(
          group => group.expense_type_catalog.id === expense.id,
        )
      ) return true
      if (
        this.posItems.find(
          group => group.expense_type_catalog_id === expense.id,
        )
      ) return true
      return false
    },

    addGroupedExpense(expense) {
      if (expense.id === this.expenseType) {
        // open modal to add new material
        this.$bvModal.show('newMaterial')
        return
      }
      this.addItem({
        name: expense.name,
        id: expense.id,
        expense_type_catalog_id: expense.id,
      })
    },
    addNewMaterial(expense) {
      this.addItem({
        ...this.newMaterial,
        id: expense.id,
        expense_type_catalog_id: this.expenseType,
        isMaterial: true,
      })
      this.$bvModal.hide('newMaterial')
      this.newMaterial = {}
    },

    saveProducts() {
      const hasInvalidPrice = this.posItems.some(item => {
        const price = Number(item.quantity)
        return item.quantity === null || item.quantity === '' || !Number.isFinite(price) || price < 0
      })
      if (hasInvalidPrice) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Captura el precio unitario de los productos seleccionados',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      if (!this.validateDecimals(6)) {
        return
      }

      this.stockable.stockable_records = []
      this.posItems.forEach(item => {
        this.stockable.stockable_records.push({
          product_catalog_id: item.id,
          price_list: this.limitDecimalPlaces(item.quantity, 6),
          out_of_stock: false,
        })
      })
      if (this.$route.params.type === 'proveedor') {
        this.stockable.stockable_type = 'Supplier'
      }
      if (this.$route.params.type === 'sucursal') {
        this.stockable.stockable_type = 'SupplierBranch'
      }
      this.addStockableProductSelections(this.stockable).then(() => {
        this.$router.push({
          name: 'supplierProductsCatalogs',
          params: { id: this.$route.params.id, type: this.$route.params.type },
        })
      })
    },

    saveQuoteProducts() {
      const products = []
      this.posItems.forEach(item => {
        products.push({
          product_catalog_id: item.id,
          quantity: item.quantity,
          quote_id: this.$route.params.quoteId,
        })
      })
      this.quote.quote_items_attributes = products
      this.editQuote(this.quote).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('quoteSaved'),
            icon: 'EditIcon',
            variant: 'success',
          },
        })
        this.$router.push({
          name: 'quotes',
          params: { projectId: response.project_id },
        })
      })
    },

    checkForAwaitingStatus(quote, tries = 5) {
      const attempts = tries
      return new Promise((resolve, reject) => {
        if (attempts <= 0) {
          reject(new Error('attempts_ran_out'))
        } else if (quote.quote_status !== 'awaiting_customer_response') {
          this.fetchQuote(quote.id).then(response => {
            if (response.quote_status === 'awaiting_customer_response') {
              resolve()
            } else {
              setTimeout(
                () => resolve(this.checkForAwaitingStatus(response, attempts - 1)),
                2500,
              )
            }
          })
        } else {
          resolve()
        }
      })
    },

    async saveAndPublish() {
      try {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('waitForBidding'),
            icon: 'ThumbsUpIcon',
            variant: 'info',
          },
        })
        this.publishLoading = true
        const products = []
        this.posItems.forEach(item => {
          products.push({
            product_catalog_id: item.id,
            quantity: item.quantity,
            quote_id: this.$route.params.quoteId,
          })
        })
        this.quote.quote_items_attributes = products
        const response = await this.editQuote(this.quote)
        await this.publishQuote(response.id)
        await this.checkForAwaitingStatus(response)
        await this.setQuoteBidding(response.id)
        this.$router.push({
          name: 'quotes',
          params: { projectId: response.project_id },
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('biddingSet'),
            icon: 'ThumbsUpIcon',
            variant: 'success',
          },
        })
      } catch (e) {
        if (e.message === 'attempts_ran_out') {
          this.$router.push({
            name: 'quotes',
            params: { projectId: this.quote.project_id },
          })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('biddingErrorAtPost'),
              icon: 'ThumbsUpIcon',
              variant: 'danger',
            },
          })
        }
      } finally {
        this.publishLoading = false
      }
    },

    saveExpenses() {
      const expense = {
        project_id: this.$route.params.projectId,
        grouped_expense_records: [],
      }
      expense.grouped_expense_records = this.posItems.map(item => ({
        expense_type_catalog_id: item.expense_type_catalog_id,
        name: item.name,
        top_quantity: item.top_quantity || 0,
        top_amount: item.top_amount,
        unit_type: item.unit_type,
        brand: item.brand,
        description: item.description,
        sku: item.sku,
      }))
      expense.grouped_expense_records = expense.grouped_expense_records.filter(
        product => {
          if (!this.groupedExpenses.find(item => item.sku === product.sku)) {
            return true
          }
          return false
        },
      )
      this.addGroupedExpenses(expense).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('dataSaved'),
            icon: 'MinimizeIcon',
            variant: 'success',
          },
        })
        this.$router.push({
          name: 'groupedExpenses',
          params: { projectId: this.$route.params.projectId },
        })
      })
    },

    filterBy() {
      this.page = 1
      this.changeProductsPagination({ field: 'page', value: this.page })
      this.fetchData()
    },

    setLimitSuppliersValue(value) {
      if (value) {
        this.quote.is_express = false
      }
    },
    setExpressValue(value) {
      if (value) {
        this.quote.limit_suppliers = false
      }
    },

    /* -------------------------------------------------------------------------- */
    /*                           INFINITE SCROLL SCRIPT                           */
    /* -------------------------------------------------------------------------- */

    handleScroll: _.debounce(async function (event) {
      try {
        if (
          event.target.offsetHeight + event.target.scrollTop
          >= event.target.scrollHeight - 5
        ) {
          // while its less than total products, keep adding up
          if (this.page < this.productsPagination.total_pages) {
            this.productsLoading = true
            this.page += 1
            this.changeProductsPagination({ field: 'page', value: this.page })
            const products = await axios.get('/v1/product_catalogs', {
              params: {
                by_active_status: true,
                by_stockable: this.isRegisteringStockableProducts ? {
                  id: this.$route.params.id,
                  type: this.stockableTypeForRoute(),
                } : null,
                by_quote_coverage: this.isQuoteCatalog
                  ? this.$route.params.quoteId
                  : null,
                by_category: this.selectedCategory
                  ? this.selectedCategory
                  : null,
                by_name: this.searchQuery ? this.searchQuery : null,
                by_product_tags: this.productTagsFilter,
                by_column: { order: 'ASC', column: 'name' },
                meta: {
                  pagination: this.productsPagination,
                },
              },
            })
            const addedProducts = [...this.products, ...products.data.data]
            products.data.data = addedProducts
            this.setProducts(products.data)
          }
        }
      } finally {
        this.productsLoading = false
      }
    }, 200),
    validateDecimals(maxDecimalPlaces = 2) {
      // this.posItems.forEach(function (item) {
      let valid = true
      for (let i = 0; i < this.posItems.length; i += 1) {
        const item = this.posItems[i]
        const decimalPart = String(item.quantity).split('.')[1]
        if (decimalPart && decimalPart.length > maxDecimalPlaces) {
        // this.quantityValid = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Solo se permiten ${maxDecimalPlaces} decimales`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          valid = false
          break
        }
      }
      return valid
    },
    limitDecimalPlaces(value, maxDecimalPlaces = 2) {
      const stringValue = String(value ?? '').replace(',', '.')
      const [integerPart, ...decimalParts] = stringValue.split('.')
      const sanitizedInteger = integerPart.replace(/\D/g, '')
      const decimalPart = decimalParts.join('').replace(/\D/g, '')

      if (decimalParts.length === 0) return sanitizedInteger

      return `${sanitizedInteger}.${decimalPart.slice(0, maxDecimalPlaces)}`
    },
    handleRequestQuoteClick() {
      if (!this.validateDecimals()) {
        return
      }
      this.$bvModal.show('confirmModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.pos-header {
  width: 100%;
  max-width: 720px;
}

.stockable-highlight {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: fit-content;
  max-width: 100%;
  padding: 0.6rem 0.85rem;
  border: 1px solid #d9e2ef;
  border-left: 4px solid var(--primary);
  border-radius: 0.7rem;
  background: linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%);
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
}

.stockable-highlight__icon {
  color: var(--primary);
  flex-shrink: 0;
}

.stockable-highlight__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stockable-highlight__label {
  font-size: 0.72rem;
  line-height: 1.1;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #5e6878;
}

.stockable-highlight__name {
  margin-top: 0.15rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #202733;
  word-break: break-word;
}

.pos {
  background-color: #f2f0f4;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 8px;
  min-height: 100%;
  height: calc(100vh - 33vh);
}
.products {
  height: calc(100vh - 360px);
}
.search-input {
  min-width: 300px;
}

.notification-number {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 3px 6px;
  border-radius: 50%;
  background-color: red;
  color: white;
}

.modal-h-100 {
  background-color: red;
}

.scrollable {
  max-height: 300px !important; /* Ajusta el valor a la altura deseada */
  overflow-y: auto;
}

.product-tags-filter {
  flex: 1 1 auto;
  min-width: 260px;
  max-width: 520px;
}

.empty-products-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 1.5rem;
  color: #6b7280;
  font-size: 1rem;
  text-align: center;
}

.classification-shell {
  margin-bottom: 1rem;
}

.classification-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.15rem;
  border: 1px solid #e1dce8;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(34, 41, 47, 0.06);
}

.classification-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #2f2546;
}

.classification-subtitle {
  margin: 0.25rem 0 0;
  color: #6e6879;
}

.classification-stats {
  min-width: 112px;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  background: #f7f5fa;
  color: #6e6879;
  text-align: right;
}

.classification-stats span {
  display: block;
  color: #340668;
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1;
}

.bulk-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid #e1dce8;
  border-radius: 8px;
  background: #fff;
}

.bulk-actions__check {
  margin-right: 0;
}

@media (max-width: 767.98px) {
  .stockable-highlight {
    width: 100%;
  }

  .classification-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .classification-stats {
    width: 100%;
    text-align: left;
  }
}
</style>
